
<!-- LiteApp: 使用 scroll-view 组件 -->
<scroll-view
  v-if="isLiteApp"
  ref="scrollViewRef"
  v-bind="scrollViewAttrs"
  v-on="scrollViewListeners"
>
  <slot />
</scroll-view>
<!-- H5: 使用 div 元素 -->
<div
  v-else
  ref="scrollRef"
  v-bind="divAttrs"
  :class="scrollClass"
  :style="scrollStyle"
  :data-show-scrollbar="showScrollbar"
>
  <slot />
</div>
